import { connectResources } from '@ds-frontend/resource'

import CampaignBannerView from './CampaignBannerView'


export default connectResources('campaignBanner')(CampaignBannerView)
